import { deleteCookie, getCookie, setCookie } from "./auth";

const AUTH_TOKEN_KEY = "admintoken";
const ACADEMY_ID_KEY = "academyId";

export const getAuthToken = () => {
  return (
    sessionStorage.getItem(AUTH_TOKEN_KEY) ||
    getCookie(AUTH_TOKEN_KEY) ||
    null
  );
};

export const hydrateAuthTokenToSession = () => {
  const token = getAuthToken();
  if (!token) return null;
  sessionStorage.setItem(AUTH_TOKEN_KEY, token);

  if (!sessionStorage.getItem(ACADEMY_ID_KEY)) {
    const academyIdFromCookie = getCookie(ACADEMY_ID_KEY);
    if (academyIdFromCookie) {
      sessionStorage.setItem(ACADEMY_ID_KEY, academyIdFromCookie);
    }
  }
  return token;
};

export const persistAuthSession = ({ token, academyId }) => {
  if (!token) return;
  sessionStorage.setItem(AUTH_TOKEN_KEY, token);
  // Keep a cookie copy to restore sessionStorage when reopening a tab.
  setCookie(AUTH_TOKEN_KEY, token, { days: 7 });
  if (academyId) {
    sessionStorage.setItem(ACADEMY_ID_KEY, academyId);
    setCookie(ACADEMY_ID_KEY, academyId, { days: 7 });
  }
};

export const clearAuthSession = () => {
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(ACADEMY_ID_KEY);
  deleteCookie(AUTH_TOKEN_KEY);
  deleteCookie(ACADEMY_ID_KEY);
};
